import axios from '~/api/axios';
import { Application } from '~/types/Application';

export const proceedManualOnboarding = () => {
  return axios.post<Application>('/stages/onboarding/manual/proceed').then((res) => res.data);
};

export const proceedTechFailedOnboarding = () => {
  return axios.post<Application>('/stages/onboarding/tech-failed/proceed').then((res) => res.data);
};

export const proceedFailedOnboarding = () => {
  return axios.post<Application>('/stages/onboarding/failed/proceed').then((res) => res.data);
};
